import * as z from "zod";

import { formatters } from "@fraction/shared";

import { STRICT_EMAIL_VALIDATE } from "./email";

export const minCurrency = (amount: number, message: string) =>
  z.string().refine((val) => formatters.number.getNumberFromString(val) >= amount, { message });

export { STRICT_EMAIL_VALIDATE as strictEmailValidate };
